import { Color } from 'three';
import { OnlyBotMaterialPreset } from '@animavirtuality/onlybots-three';
import { BotInstancedMesh } from '@/lib/types';

export const DEFAULT_COLOR = new Color(0xffffff).convertSRGBToLinear();

export const applyMaterial = (mesh: BotInstancedMesh, color: Color, preset: OnlyBotMaterialPreset): void => {
    const material = mesh.material;
    if (material) {
        material.color.setHex(color.getHex()).convertSRGBToLinear();
        material.emissive.setHex(color.getHex()).convertSRGBToLinear();
        material.emissiveIntensity = preset.emissive ? 0.1 : 0;
        material.roughness = preset.roughness;
        material.metalness = preset.metalness;
        material.clearcoat = preset.clearcoat;
        material.clearcoatRoughness = preset.clearcoatRoughness;
    }
};
